(function(){
'use strict';
var d=document,dialog=d.getElementById('wkNavV3');
if(!dialog)return;
if(new URLSearchParams(location.search).get('wkmnav')==='1')d.documentElement.classList.add('wk-mnav-force');
var input=d.getElementById('wkNavV3Search'),list=dialog.querySelector('.wk-nav-v3-list'),lastFocus=null;
function triggers(expanded){d.querySelectorAll('[data-wk-nav-open],.wk-nav-v3-toggle').forEach(function(b){b.setAttribute('aria-expanded',String(expanded))});}
function filter(){
var q=input.value.trim().toLocaleLowerCase();
function visit(li,parentMatches){
var detail=li.querySelector(':scope > details');
if(!detail){var a=li.querySelector(':scope > a');var hit=parentMatches||!q||!!(a&&a.textContent.toLocaleLowerCase().indexOf(q)>-1);li.hidden=!hit;return hit}
var own=detail.querySelector(':scope > summary').textContent.toLocaleLowerCase();
var match=parentMatches||!!q&&own.indexOf(q)>-1,any=false;
detail.querySelectorAll(':scope > ul > li').forEach(function(child){if(visit(child,match))any=true});
var show=!q||match||any;li.hidden=!show;
if(q&&show)detail.open=true;return show;
}
var any=false;list.querySelectorAll(':scope > ul > li').forEach(function(li){if(visit(li,false))any=true});list.querySelector('.wk-nav-v3-empty').hidden=any;
}
function open(target,button){
lastFocus=button||d.activeElement;input.value='';filter();
dialog.querySelectorAll('details').forEach(function(el){el.open=false});
var selected=target==='shop'?dialog.querySelector('[data-wk-nav-shop]'):d.getElementById(target||'');
if(selected){var parent=selected.parentElement;while(parent&&parent!==dialog){if(parent.tagName==='DETAILS')parent.open=true;parent=parent.parentElement}selected.open=true}
if(typeof dialog.showModal==='function'){if(!dialog.open)dialog.showModal()}else dialog.setAttribute('open','');
d.documentElement.classList.add('wk-nav-v3-open');triggers(true);
var focus=selected?selected.querySelector('summary'):dialog.querySelector('[data-wk-nav-close]');
if(focus)focus.focus({preventScroll:true});
if(selected)selected.scrollIntoView({block:'nearest'});
}
function clean(){d.documentElement.classList.remove('wk-nav-v3-open');triggers(false);if(lastFocus&&lastFocus.isConnected)lastFocus.focus({preventScroll:true})}
function close(){if(typeof dialog.close==='function')dialog.close();else{dialog.removeAttribute('open');clean()}}
d.addEventListener('click',function(e){
var toggle=e.target.closest('[data-wk-nav-open],.wk-nav-v3-toggle');
if(toggle){e.preventDefault();open(toggle.getAttribute('data-wk-nav-open'),toggle);return}
if(e.target.closest('[data-wk-nav-close]')){e.preventDefault();close()}
});
dialog.addEventListener('close',clean);
dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
dialog.addEventListener('keydown',function(e){if(e.key==='Escape'&&typeof dialog.close!=='function'){e.preventDefault();close()}});
input.addEventListener('input',filter);
addEventListener('pageshow',function(){if(!dialog.open){d.documentElement.classList.remove('wk-nav-v3-open');triggers(false)}});
})();